<ion-app>
  <ion-split-pane when="false" contentId="main">
    <p style="visibility: hidden">App Version 2.0.1</p>
    <ion-menu  (ionWillOpen)="checkhospital()" [swipeGesture]="false" contentId="main" type="overlay">
      <ion-content>
        <ion-list
          style="overflow: hidden"
          class="md:hidden h-[100%] bg-white"
          id="menu-list"
        >
          <div class="mt-8">
            <img
              *ngIf="auth.UserObj?.avatar"
              src="{{ auth.UserObj.avatar }}"
              class="mx-auto"
              style="width: 70px; height: 70px; border-radius: 40px"
            />
            <p *ngIf="auth.UserObj?.username" class="text-center name my-1">
              {{ auth.UserObj.username }}
            </p>
            <p *ngIf="auth.UserObj?.email" class="text-center email my-1">
              {{ auth.UserObj.email }}
            </p>
            <p
              (click)="close('user-setting')"
              class="text-center cursor-pointer setting my-1"
            >
              Edit Profile Settings
            </p>
          </div>
          <div class="mt-2">
            <ion-item  class="mt-2" lines="none" slot="header">
              <ion-icon (click)="close()" name="log-out-outline" size="small"></ion-icon>
              <ng-select
              class="border-none w-full select-hospital-mobile"
              [(ngModel)]="selectedHospital"
              (change)="setHospital($event)"
              [items]="hospitals"
              bindValue="id"
              bindLabel="name"
              [searchable]="false"
              [clearable]="false"
              appendTo="body"
              placeholder="Select an option"
            >
            </ng-select>
            </ion-item>
            <ion-item class="mt-2" lines="none" slot="header">
              <ion-icon
                [src]="'assets/hospital/side menu/Dashboard.svg'"
                name="card"
                size="small"
              ></ion-icon>
              <ion-label
                (click)="close('home')"
                class="ion-padding-start cursor-pointer"
                >Home</ion-label
              >
            </ion-item>
            <ion-accordion-group>
              <ion-accordion
                *ngFor="let page of appPages; let i = index"
                (click)="setId(i)"
                lines="none"
                detail="false"
              >
                <ion-item
                  class="field mt-2"
                  lines="none"
                  [ngClass]="{ my_class: currentSelected === i }"
                  slot="header"
                >
                  <ion-icon [src]="page.sort" size="small"></ion-icon>
                  <ion-label class="ion-padding-start">{{
                    page.name
                  }}</ion-label>
                </ion-item>
                <div *ngFor="let sub of page.sub" slot="content">
                  <ion-item lines="none">
                    <ion-icon
                      style="font-size: 8px"
                      class="my-1 pl-7"
                      [src]="icon"
                    ></ion-icon>
                    <ion-label
                      (click)="close(sub.url)"
                      class="cursor-pointer ml-4"
                      >{{ sub.title }}</ion-label
                    >
                  </ion-item>
                </div>
              </ion-accordion>
            </ion-accordion-group>
            <ion-item
              class="mt-2"
              *ngFor="let page of appPages2; let i = index"
              lines="none"
              [ngClass]="{ my_class: selected === i }"
              (click)="setCurrent(i)"
              slot="header"
            >
              <ion-icon [src]="page.sort" size="small"></ion-icon>
              <ion-label
                (click)="close(page.url)"
                class="ion-padding-start cursor-pointer"
                >{{ page.name }}</ion-label
              >
            </ion-item>

            <ion-item class="mt-2" lines="none" slot="header">
              <ion-icon name="log-out-outline" size="small"></ion-icon>
              <ion-label
                (click)="logout()"
                class="ion-padding-start cursor-pointer"
                >Logout</ion-label
              >
            </ion-item>
          </div>
        </ion-list>

        <ion-list
          style="overflow: auto"
          class="hidden h-[100%] bg-[#00205b] md:block"
          id="menu-list"
        >
          <div class="bg-[#00205b] mt-16">
            <div style="display: flex; justify-content: flex-end">
              <ion-icon
                (click)="close()"
                style="color: white"
                size="large"
                class="mr-5 mb-2 cursor-pointer"
                name="arrow-back-circle-outline"
                slot="end"
              ></ion-icon>
            </div>

            <!-- <ion-item *ngIf=" show">
              <ion-label>Hospital</ion-label>
              <ion-select [(ngModel)]="selectedHospital" (ionChange)="setHospital($event)">
                <ion-select-option *ngFor="let hospital of hospitals" [value]="hospital.id">
                  {{ hospital.name }}
                </ion-select-option>
              </ion-select>
            </ion-item> -->


              <ng-select
                class="bg-[#00205b] text-white select-hospital w-full"
                [(ngModel)]="selectedHospital"
                (change)="setHospital($event)"
                [items]="hospitals"
                bindValue="id"
                bindLabel="name"
                [searchable]="false"
                [clearable]="false"
                appendTo="body"
                placeholder="Select Hospital"
              >
              </ng-select>

            <ion-item class="mt-2" lines="none" slot="header">
              <ion-icon
                [src]="'assets/hospital/side menu/Dashboard.svg'"
                size="small"
              ></ion-icon>
              <ion-label
                style="color: white"
                (click)="close('home')"
                class="ion-padding-start cursor-pointer"
                >Home</ion-label
              >
            </ion-item>
            <ion-accordion-group>
              <ion-accordion
                *ngFor="let page of appPages; let i = index"
                (click)="setId(i)"
                lines="none"
                detail="false"
              >
                <ion-item
                  class="web"
                  lines="none"
                  [ngClass]="{ my_class: currentSelected === i }"
                  slot="header"
                >
                  <ion-icon
                    class="my-1"
                    [src]="page.sort"
                    size="small"
                  ></ion-icon>
                  <ion-label class="ion-padding-start my-1" color="light">{{
                    page.name
                  }}</ion-label>
                </ion-item>
                <div *ngFor="let sub of page.sub" slot="content">
                  <ion-item lines="none">
                    <ion-icon
                      style="font-size: 8px"
                      class="my-1 pl-7"
                      [src]="icon"
                    ></ion-icon>
                    <ion-label
                      style="padding-left: 3%"
                      class="my-1"
                      (click)="close(sub.url)"
                      class="cursor-pointer"
                      color="light"
                      >{{ sub.title }}</ion-label
                    >
                  </ion-item>
                </div>
              </ion-accordion>
            </ion-accordion-group>
            <ion-item
              class="web my-1"
              *ngFor="let page of appPages2; let i = index"
              lines="none"
              [ngClass]="{ my_class: selected === i }"
              (click)="setCurrent(i)"
              slot="header"
            >
              <ion-icon [src]="page.sort" size="small"></ion-icon>
              <ion-label
                class="ion-padding-start cursor-pointer"
                (click)="close(page.url)"
                color="light"
                >{{ page.name }}</ion-label
              >
            </ion-item>
          </div>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main" [swipeGesture]="false"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
